.component-table {
  width: 100%;
}

.component-table-thead {
  background-color: #38468c;
  color: #ffffff;
}

.component-table-tr {
  background-color: #38468c;
  color: #ffffff;
}

.component-table-th {
  border: 1px solid;
}

.component-table-td {
  border: 1px solid;
  padding: 5px;
}

.component-table td > fr-vrf-button {
  margin: 5px 10px 5px 0;
}

pre {
  margin: 0 5px;
  border: 1px solid gray;
  border-radius: 4px;
  background: lightyellow;
}

code {
  font-family: var(--vrf-font-family);
}

fr-vrf-radio-button-field[id="commonSearchPageId"] vaadin-radio-button {
  display: block;
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

fr-vrf-text-display-field.text-display-field-style-apply [part="content"] {
  background-color: #38468c;
  color: #ffffff;
}
